import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

function id() {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export default function Tracker() {
  const location = useLocation();
  useEffect(() => {
    let vid = localStorage.getItem("fx_vid");
    if (!vid) { vid = id(); localStorage.setItem("fx_vid", vid); }
    let sid = sessionStorage.getItem("fx_sid");
    if (!sid) { sid = id(); sessionStorage.setItem("fx_sid", sid); }
    api.post("/track", { path: location.pathname, visitor_id: vid, session_id: sid, referrer: document.referrer || "" }).catch(() => {});
  }, [location.pathname]);
  return null;
}
